module.exports = __webpack_public_path__ + "static/media/12928219_995121243908599_464696674554622850_n.9cd5ff6f.jpg";